// extracted by mini-css-extract-plugin
export default {"container":"TzRum0A1XEKtG5zcp6AR","box":"I5Uz21mOAgb0rCMg1nXA"};